import { Box, Fade, Stack, Typography, Zoom } from '@mui/material'
import theme from '../../theme'

type SplashProps = {
  show: boolean
}

function Splash({ show }: SplashProps) {
  return (
    <Fade in={show} timeout={400} appear={false}>
      <Box
        sx={{
          bgcolor: theme.palette.background.paper,
          display: 'flex',
          opacity: 0,
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          width: '100%',
          position: 'absolute',
          zIndex: 1000000,
        }}
      >
        <Zoom in={true} timeout={400}>
          <Stack alignItems="center">
            <Box component="img" src="/img/MyntLogo.png" sx={{ width: '250px', height: 'auto' }} />
            <Typography variant="h5" sx={{ transform: 'translateY(-30px)', letterSpacing: 4 }}>
              TECHNOLOGIES
            </Typography>
          </Stack>
        </Zoom>
      </Box>
    </Fade>
  )
}

export default Splash
